import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=40172700&"
import script from "./ActiveFilters.vue?vue&type=script&lang=ts&"
export * from "./ActiveFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports